import LinkIcon from './component-lib.esm15.js';
import EmbedOutlineIcon from './component-lib.esm63.js';
import DynamicFormIcon from './component-lib.esm66.js';
import RssIcon from './component-lib.esm72.js';
import EmailIcon from './component-lib.esm17.js';
import PhoneIcon from './component-lib.esm64.js';
import TitleIcon from './component-lib.esm45.js';
import CarouselIcon from './component-lib.esm37.js';
import MinusIcon from './component-lib.esm52.js';
import GroupIcon from './component-lib.esm103.js';
import TextBoxOutlineIcon from './component-lib.esm92.js';
import CardAccountDetailsOutlineIcon from './component-lib.esm105.js';
import DonationIcon from './component-lib.esm86.js';
import RequestIcon from './component-lib.esm89.js';
import GridIcon from './component-lib.esm83.js';
import ShopIcon from './component-lib.esm102.js';
const LINK_ICONS = {
  LinkIcon,
  EmbedOutlineIcon,
  DynamicFormIcon,
  RssIcon,
  EmailIcon,
  PhoneIcon,
  TitleIcon,
  CarouselIcon,
  MinusIcon,
  GroupIcon,
  TextBoxOutlineIcon,
  CardAccountDetailsOutlineIcon,
  DonationIcon,
  RequestIcon,
  GridIcon,
  ShopIcon
};
export { LINK_ICONS };